import "./style.css";
import { App } from "./app";
import { errorMessage } from "./util/format";

/**
 * Entry point. Failures during boot are shown in the page itself: the extension runs in an
 * iframe inside Trimble Connect, where a blank panel gives the user nothing to act on and
 * the browser console is easy to miss.
 */
function showBootError(message: string): void {
  const app = document.getElementById("app");
  if (!app) return;
  const overlay = document.createElement("div");
  overlay.id = "boot-error";
  overlay.innerHTML =
    `<div><strong>The 3D viewer could not start.</strong><br>` +
    `<span style="color:var(--muted)">${escapeHtml(message)}</span></div>`;
  app.append(overlay);
}

function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c] ?? c,
  );
}

const canvas = document.getElementById("viewport") as HTMLCanvasElement | null;
if (!canvas) {
  showBootError("The viewport canvas is missing from the page.");
} else {
  try {
    const app = new App(canvas);
    void app.start();
    window.addEventListener("beforeunload", () => app.dispose());
  } catch (error) {
    console.error(error);
    showBootError(errorMessage(error));
  }
}

window.addEventListener("unhandledrejection", (event) => {
  console.error("[unhandled]", event.reason);
});
